import { useState } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import { componentStyles } from "./cards-component.scss";

const CardsComponent = ({ cardItems, showMoreText, showLessText, title }) => {
  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => {
    if (showAll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setShowAll(!showAll);
  };

  const renderCards = () => {
    const visibleSets = showAll ? cardItems : cardItems.slice(0, 9);
    return visibleSets.map((set, index) => (
      <a key={index} href={set.pageUrl} className="card">
        <div className="image-wrapper">
          <PictureComponent src={set.thumbnailUrl} />
        </div>
        <div className="card-content">
          <div className="card-title">{set.title}</div>
          <div className="card-description">{set.description}</div>
        </div>
      </a>
    ));
  };
  return (
    <div className="component-container">
      {title && <div className="title-wrapper">{title}</div>}
      <div className="cards-wrapper">{renderCards()}</div>
      {cardItems.length > 9 && (
        <div className="show-more" onClick={toggleShowAll}>
          {showAll ? showLessText : showMoreText}
        </div>
      )}
      <style jsx>{componentStyles}</style>
    </div>
  );
};
export default CardsComponent;
